export enum PatchCode {
  UPDATE_WIDGET_CONFIGS = "UPDATE_WIDGET_CONFIGS",
  PATCH_STOREFRONT_TREATMENT = "PATCH_STOREFRONT_TREATMENT",
}
